import { Component, Input, OnInit } from '@angular/core';
import { SidenavComponent } from '../../sidenav.component';

@Component({
  selector: 'app-contact-us',
  templateUrl: 'contact-us.component.html',
  styleUrls: ['contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  @Input() sidenav: SidenavComponent;

  constructor() {}

  ngOnInit(): void {}
}
